import nestAxios from './_nestAxios'

export const iniciarJob = (tipoOperacion, params) =>
  nestAxios.post('/jobs/iniciar', { tipoOperacion, params })

export const obtenerPendientes = () =>
  nestAxios.get('/jobs/pendientes')

export const obtenerLista = () =>
  nestAxios.get('/jobs/lista')

export const obtenerEstado = id =>
  nestAxios.get(`/jobs/${id}/estado`)

export const marcarVisto = id =>
  nestAxios.put(`/jobs/${id}/visto`)

export const marcarTodosVistos = () =>
  nestAxios.put('/jobs/marcar-todos-vistos')
